import { render, staticRenderFns } from "./EditDietaryRestrictionsDialog.vue?vue&type=template&id=58512b76&scoped=true"
import script from "./EditDietaryRestrictionsDialog.vue?vue&type=script&lang=js"
export * from "./EditDietaryRestrictionsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDietaryRestrictionsDialog.vue?vue&type=style&index=0&id=58512b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58512b76",
  null
  
)

export default component.exports